import intl from "react-intl-universal";

import { ISelectOption } from "types";

export const formatNumber = (playerNumber: number) => {
  if (playerNumber === -1) {
    return intl.get("PLAYER_NOT_ASSIGN_NUMBER");
  }
  return playerNumber.toString();
};

export const buildPlayerNameWithJerseyNumber = (
  name: string,
  number?: number
) => {
  if (!number || number < 0) {
    return name;
  }

  return `${name} (${number})`;
};

export const buildNumberOptions = (): ISelectOption[] => {
  const options = Array.apply(null, Array(100)).map((_, index) => ({
    label: index.toString(),
    value: index,
  }));
  options.unshift({
    label: intl.get("PLAYER_NOT_ASSIGN_NUMBER"),
    value: -1,
  });
  return options;
};
